<template>
    <div class="container">
        <div v-html="html" @click="to"></div>
    </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";

const props = defineProps(['id'])
const emit = defineEmits()

const html = ref('')

const to = async (event) => {
    let faq = await getFaq(event.target.dataset.id)
    emit('getFaq', faq)
}

const getFaq = async (id) => {
    return (await window.axios.get(`/api/configurations/faqs/${id}`)).data.data
}

onMounted(async () => {
    let faq = await getFaq(props.id);
    html.value = faq.html
    await (new Promise(resolve => setTimeout(resolve, 1)));
    const elementos = document.querySelectorAll("[data-id]");
    for (const el of elementos) {
        let faq = await getFaq(el.getAttribute('data-id'));
        el.setAttribute('title', faq.description);
    }
})
</script>

<style scoped>

.container {
    padding: 0;
}

:deep(a) {
    color: blue !important;
    text-decoration: underline !important;
    cursor: pointer !important;
}

:deep(a:hover) {
    color: darkblue !important;
}
</style>